<div class="master_uploader">
  <div class="img_uploader">
    <p>Upload      <span> CSV </span>
      <span class="dimensions">Allowed Types : csv</span>
    </p>
    <img src="../../../../../../../assets/images/icons/file.svg" alt="">
    <input type="file" class="file_input" #fileVariable (change)="setFiles(fileVariable.files)">
  </div>
  <div class="uploaded_img">
    <div class="container" *ngIf="lines.length && linesR.length">
      Please verify the content before save.
      <table class="table table-bordered table-dark mt-5">
        <thead>
          <tr>
            <th *ngFor="let item of lines[0]; let i = index">{{item}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of linesR[0]; let i = index">
            <td *ngFor="let itemm of lines[0]; let j = index">{{item[j]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
